import latinize from 'latinize';

/**
 * Convert a display string (tag name, author name, etc.) into a URL slug:
 * lowercased, with runs of whitespace collapsed to single hyphens.
 *
 * Shared between frontend and backend so link generation (frontend) and
 * server-side tag/author filtering (backend) stay in sync.
 */
export function stringToSlug(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, '-');
}

/**
 * Normalize a team name into a URL-safe slug. Shared between the onboarding
 * wizard (frontend availability checks) and team create/update (backend
 * reservation) so both derive the SAME slug from the same raw input — using
 * `latinize` for consistent transliteration of accented / non-Latin characters
 * (e.g. "Straße" -> "strasse") and collapsing repeated hyphens to one.
 */
export function normalizeTeamSlug(value: string): string {
  return latinize(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-');
}
